var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52077 2.46603C8.52077 2.17148 8.28199 1.9327 7.98744 1.9327C7.69289 1.9327 7.4541 2.17148 7.4541 2.46603L7.45411 7.96668L1.95352 7.96668C1.65897 7.96668 1.42018 8.20546 1.42018 8.50001C1.42018 8.79456 1.65897 9.03335 1.95352 9.03335L7.45411 9.03335L7.45411 14.534C7.45411 14.8285 7.69289 15.0673 7.98744 15.0673C8.282 15.0673 8.52078 14.8285 8.52078 14.534L8.52078 9.03335L14.0215 9.03335C14.316 9.03335 14.5548 8.79457 14.5548 8.50002C14.5548 8.20546 14.316 7.96668 14.0215 7.96668L8.52078 7.96668L8.52077 2.46603Z",
    fill: "#6D6AFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPrimary);
export default __webpack_public_path__ + "static/media/add-primary.5b8c449aa90e37e27085f71fba163f73.svg";
export { ForwardRef as ReactComponent };